const csrResponseHasError = response => (response?.error || response?.payload?.hasError) ?? false

export default csrResponseHasError
